"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RedisStorageServer = exports.RedisKeyPrefix = void 0;
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _api = require("@whitbread-eos/api");
var _ioredis = _interopRequireDefault(require("ioredis"));
var _config = _interopRequireDefault(require("next/config"));
var _logger = require("../logger/logger");
var RedisKeyPrefix = exports.RedisKeyPrefix = function (RedisKeyPrefix) {
  RedisKeyPrefix["PI"] = "premier-inn";
  RedisKeyPrefix["BB"] = "bb";
  RedisKeyPrefix["CCUI"] = "ccui";
  RedisKeyPrefix["COMMON"] = "fe";
  return RedisKeyPrefix;
}({});
class RedisStorageServer {
  static getInstance() {
    var keyPrefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : RedisKeyPrefix.PI;
    if (typeof window !== 'undefined') {
      throw new Error('RedisStorage should only be used on the server side.');
    }
    var {
      publicRuntimeConfig = {}
    } = (0, _config.default)() || {};
    var {
      NEXT_PUBLIC_REDIS_HOST,
      NEXT_PUBLIC_REDIS_PORT
    } = publicRuntimeConfig;
    _logger.logger.info({
      keyPrefix,
      NEXT_PUBLIC_REDIS_HOST,
      NEXT_PUBLIC_REDIS_PORT
    }, 'Initializing Redis cluster');
    if (!NEXT_PUBLIC_REDIS_HOST || !NEXT_PUBLIC_REDIS_PORT) {
      throw new Error('Redis host or port is not available');
    }
    var cluster = new _ioredis.default.Cluster([{
      port: NEXT_PUBLIC_REDIS_PORT,
      host: NEXT_PUBLIC_REDIS_HOST
    }], {
      keyPrefix: "".concat(keyPrefix, "::"),
      scaleReads: 'all',
      dnsLookup: (address, callback) => callback(null, address),
      redisOptions: {
        tls: {}
      }
    });
    return new RedisStorageServer(cluster);
  }
  constructor(redis) {
    this.redis = redis;
    this.redis.on('error', error => {
      _logger.logger.info({
        error
      }, 'Redis cluster error');
      this.cleanup();
    });
    this.redis.on('connect', () => {
      _logger.logger.info('Redis cluster connected');
    });
  }
  setItem(key, value) {
    var _arguments = arguments,
      _this = this;
    return (0, _asyncToGenerator2.default)(function* () {
      var ttlSeconds = _arguments.length > 2 && _arguments[2] !== undefined ? _arguments[2] : _api.DEFAULT_REDIS_TTL;
      try {
        _logger.logger.info({
          key,
          value,
          ttlSeconds
        }, 'Setting item in Redis');
        yield _this.redis.set(key, value, 'EX', ttlSeconds);
      } catch (error) {
        _logger.logger.error({
          error,
          key
        }, 'Error setting item in Redis');
        return;
      }
    })();
  }
  getItem(key) {
    var _this2 = this;
    return (0, _asyncToGenerator2.default)(function* () {
      try {
        _logger.logger.info({
          key
        }, 'Getting item from Redis');
        return yield _this2.redis.get(key);
      } catch (error) {
        _logger.logger.error({
          error,
          key
        }, 'Error getting item from Redis');
        return null;
      }
    })();
  }
  removeItem(key) {
    var _this3 = this;
    return (0, _asyncToGenerator2.default)(function* () {
      try {
        _logger.logger.info({
          key
        }, 'Removing item from Redis');
        yield _this3.redis.del(key);
      } catch (error) {
        _logger.logger.error({
          error,
          key
        }, 'Error removing item from Redis');
        return;
      }
    })();
  }
  cleanup() {
    var _this4 = this;
    return (0, _asyncToGenerator2.default)(function* () {
      try {
        if (_this4.redis) {
          yield _this4.redis.quit();
        }
      } catch (error) {
        _logger.logger.error({
          error
        }, 'Error during cleanup:');
      }
    })();
  }
}
exports.RedisStorageServer = RedisStorageServer;